import type { Client } from 'openapi-fetch';
import { createApiClient } from '@ngsos/portal-core/http';
import type { EedPaths } from '@ngsos/portal-core/api/eed';
import { getAuthSession } from './auth';
import { getEedServerUrl } from './baseUrls';

let client: Client<EedPaths> | undefined;

function ensureClient(): Client<EedPaths> {
  client ??= createApiClient<EedPaths>(getEedServerUrl(), getAuthSession());
  return client;
}

export const eedApi: Client<EedPaths> = new Proxy({} as Client<EedPaths>, {
  get(_target, property) {
    return Reflect.get(ensureClient(), property);
  },
});
